import api from "../../../api";

export const requestGetPartRequestImages = (id) => api.get(`/partrequestimage/images/${id}`);

export const requestDeletePartrequestImage = (image_id) => api.delete(`/partrequestimage/images/${image_id}`);
